import React, { useEffect, useRef, useState } from "react";
import { useSpring, animated } from "@react-spring/web";

export default function AnimacionScroll() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);



  // Animación para el recuadro derecho (imagen)
  const animImagen = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0px) scale(1)" : "translateY(10px) scale(1)",
    config: { tension: 140, friction: 25 },
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="py-0 px-0 lg:px-0 bg-slate-950 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-0 mb-0">

          {/* Columna derecha animada con imagen */}
          <animated.div style={animImagen} className="md:w-full">
            <div className="bg-slate-900 rounded-xl aspect-video relative overflow-hidden shadow-2xl">
              <img
                src="/MATTERPORT.avif"   // asegúrate que esté en public/MATTERPORT.avif
                alt=""
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="bg-black/50 backdrop-blur-sm px-4 py-1 border border-white/20 text-xs font-mono uppercase tracking-widest">Escaneo Virtual 3D</span>
              </div>
            </div>
          </animated.div>

        </div>
      </div>
    </div>
  );
}
